<template>
  <el-dialog :title="title" :visible.sync="visiable" :close-on-click-modal="false" width="50%" @close="onClose()">
    <el-form :model="replyInfo" :rules="rules" ref="replyInfo" label-width="100px" class="messageTip">
      <!-- 只读 -->
      <el-form-item label="用户ID:" v-if="type !== 0">
        <el-tag v-for="(name, i) in userNameList" :key="i" size="medium" style="margin-left: 5px">
          {{ name }}
        </el-tag>
      </el-form-item>
      <div class="lx-flex-row">
        <el-form-item label="用户ID:" v-if="type === 0">
          <span>{{ userName }}</span>
        </el-form-item>
        <el-form-item label="消息类型:">
          <span>{{ messageType }}</span>
        </el-form-item>
        <el-form-item v-if="orderNo" :label="messageType == '批次消息' ? '批次编号' : '订单编号'">
          <span>{{ orderNo }}</span>
        </el-form-item>
      </div>
      <el-form-item label="模板">
        <el-select v-model="replyInfo.remindingTitleJa" placeholder="请选择" @change="onChange">
          <el-option v-for="item in messageList" :key="item.id" :value="item.remindingTitle" :label="item.remindingTitle">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 内容 -->
      <el-form-item label="标题:" prop="remindingTitle">
        <el-input placeholder="请输入标题" v-model="replyInfo.remindingTitle"></el-input>
      </el-form-item>
      <el-form-item label="内容:" prop="remindingContent">
        <!-- <el-input v-model="replyInfo.remindingContent" type="textarea" :autosize='{minRows: 4}'></el-input> -->
        <quill-editor ref="text" v-model="replyInfo.remindingContent" :options="editorOption" />
      </el-form-item>
      <el-form-item label="跳转链接:" prop="url">
        <el-input placeholder="请输入跳转链接" v-model="replyInfo.url"></el-input>
      </el-form-item>

      <!-- 上传图片 -->
      <el-form-item label="图片:">
        <!--<el-upload class="editor-slide-upload" action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj"-->
        <!--  list-type="picture-card" :file-list="listObj" :show-file-list="true" :on-remove="handleImgRemove"-->
        <!--  :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :limit="9" :multiple="true"-->
        <!--  accept="image/png,image/jpeg" :on-preview="handlePictureCardPreview" :on-exceed="handleExceedImage">-->
        <!--  <el-button size="small" type="primary">点击上传</el-button>-->
        <!--  <div ref="preview" @paste="handlePaste" class="paste-img"></div>-->
        <!--</el-upload>-->
        <!--<el-dialog :append-to-body="true" :visible.sync="viewVisible">-->
        <!--  <img width="100%" :src="viewImageUrl" alt="" />-->
        <!--</el-dialog>-->

        <my-upload v-model="replyInfo.replyPicture" :limit="9" multiple accept=".jpg,.png,.jpeg"/>
      </el-form-item>
      <!-- 上传视频 -->
      <el-form-item label="上传视频">
        <my-upload v-model="replyInfo.video" :limit="1" listType="picture-card video" accept=".mp4" />
      </el-form-item>
      <!-- 上传附件 -->
      <el-form-item label="上传附件">
        <my-upload v-model="newAttachment" :keyObject="{ name: 'name', url: 'url' }" mode="array" :limit="3"
          listType="text" :multiple="true" :accept="'.xls,.xlsx,.pdf,.mp4,.ai,.zip,.rar'">
          <el-button>上传附件</el-button>
        </my-upload>
        <!-- <el-upload
          class="editor-slide-upload"
          action=""
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUploadFile"
          :before-remove="beforeRemove"
          :on-success="handleOrderInfo"
          :show-file-list="true"
          :on-exceed="handleExceed"
          :file-list="attachmentList"
          :http-request="excelUploadRequest"
          :limit="limit"
          :multiple="true"
        >
          <el-button class="search-btn btn-blue">上传附件</el-button>
        </el-upload> -->
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button class="form-btn btn-gray" @click="onClose">取 消</el-button>
      <el-button class="form-btn btn-blue" @click="replySave('replyInfo')">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Oss from "../../assets/js/oss.js";
const toolbarOptions = [
  ["bold"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
];
export default {
  name: "MessageTip",
  props: {
    title: {
      type: String,
      default: "提醒",
    },
    visiable: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
    // 用户名称
    userName: {
      type: String,
      default: "",
    },
    // 用户名称列表
    userNameList: {
      type: Array,
      default: () => [],
    },
    // 消息类型
    messageType: {
      type: String,
      default: "普通消息",
    },
    // 订单编号
    orderNo: {
      type: [String, Number],
      default: "",
    },
    // 消息提醒请求地址（单条）
    httpUrl: {
      type: String,
      default: "",
    },
    // 群发请求地址（群发）
    massMessageHttpUrl: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 3,
    },
    // 0单发，1群发
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      newAttachment: [],
      viewImageUrl: "",
      viewVisible: false,
      messageList: [],
      replyInfo: {
        id: "",
        orderId: "",
        remindingUserName: "",
        remindingUserNameList: [],
        remindingTitle: "",
        remindingTitleJa: "",
        remindingContent: "",
        url: "",
        replyPicture: "",
        attachment: "",
      },
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions,
          },
        },
      },
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      rules: {
        remindingTitleJa: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        remindingContent: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
        ],
      },
      attachmentList: [],
      listObj: [],
    };
  },
  watch: {
    visiable(val) {
      console.log("----" + val);
      if (val) {
        this.attachmentList = [];
        this.doReset().then(() => {
          this.getMessageList();
          this.storeMessage(0);
        });
      } else {
        this.storeMessage(1);
      }
    },
  },
  methods: {
    storeMessage(type) {
      let key = [];
      if (this.id != undefined && this.id != "") {
        key.push(`messageId_${this.id}`);
      }

      if (this.userName != undefined && this.userName != "") {
        key.push(`userName_${this.userName}`);
      }

      if (this.orderNo != undefined && this.orderNo != "") {
        key.push(`orderNo_${this.orderNo}`);
      }

      let messageKey = key.join("_");
      if (messageKey !== "") {
        //0读 1写
        if (type === 0) {
          let message = localStorage.getItem(`message_${messageKey}`);
          if (message != null) {
            this.replyInfo = Object.assign(this.replyInfo, JSON.parse(message));
          }

          let attachment = localStorage.getItem(
            `messageAttachment_${messageKey}`
          );
          if (attachment != null) {
            this.attachmentList = JSON.parse(attachment);
          }

          let img = localStorage.getItem(`messageImg_${messageKey}`);
          if (img != null) {
            this.listObj = JSON.parse(img);
          }
        } else if (type === 1) {
          if (this.attachmentList.length > 0) {
            localStorage.setItem(
              `messageAttachment_${messageKey}`,
              JSON.stringify(this.attachmentList)
            );
          }

          const arr = Object.keys(this.listObj).map((v) => this.listObj[v]);
          if (Oss.checkAllSuccess(this.listObj)) {
            if (arr.length > 0) {
              localStorage.setItem(
                `messageImg_${messageKey}`,
                JSON.stringify(arr)
              );
            }
          }

          if (
            this.replyInfo.remindingTitle != "" ||
            this.replyInfo.remindingContent != "" ||
            this.replyInfo.url != ""
          ) {
            localStorage.setItem(
              `message_${messageKey}`,
              JSON.stringify(this.replyInfo)
            );
          }
        } else {
          //清除
          localStorage.removeItem(`message_${messageKey}`);
          localStorage.removeItem(`messageAttachment_${messageKey}`);
          localStorage.removeItem(`messageImg_${messageKey}`);
        }
      }
    },
    handlePictureCardPreview(file) {
      this.viewImageUrl = file.url;
      this.viewVisible = true;
    },
    // 获取复制图片处理
    async handlePaste(event) {
      const files = (event.clipboardData || window.clipboardData).files;
      if (!files || files.length === 0) {
        this.$message.error("当前浏览器不支持本地");
        return;
      }
      // 搜索剪切板items
      for (const file of files) {
        if (file) {
          if (file.type.indexOf("image") === -1) {
            return this.$message.error("粘贴内容非图片");
          }
          let formdata = new FormData();
          formdata.append("file", file);
          // 数据保存
          const { data: res } = await this.$http.post(
            "cmUser/message/uploadFile",
            formdata
          );
          if (res.code === 200) {
            this.listObj.push({
              name: res.data.fileName,
              url: res.data.filePath,
              hasSuccess: true,
              uid: Date.now(),
            });
          }
        }
      }
    },
    onChange(val) {
      const obj = this.messageList.find((item) => item.remindingTitle === val);
      this.replyInfo.remindingTitle = obj.remindingTitleJa;
      this.replyInfo.remindingContent = obj.remindingContentJa.replaceAll(
        "\n",
        "<br/>"
      );
      this.replyInfo.url = obj.url;
    },
    getMessageList() {
      this.$http.get("template/message/getList").then((res) => {
        this.messageList = res.data.data;
      });
    },
    replySave(formName) {
      //提醒弹窗保存按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addReply();
        } else {
          this.$message.error("必填项不能为空，请重新填写并提交！");
          return false;
        }
      });
    },
    async addReply() {
      //添加
      if (!this.handleImgSubmit()) {
        return false;
      }

      let messageTypeArr = [
        "",
        "订单消息",
        "其他消息",
        "普通消息",
        "订单修改",
        "批次消息",
        "不良消息",
      ];
      let messageType = messageTypeArr.indexOf(this.messageType);
      if (messageType > 0) {
        this.replyInfo.messageType = messageType;
      }

      this.replyInfo.orderId = this.orderNo;
      this.replyInfo.id = this.id;
      this.replyInfo.me = this.id;

      let url = this.httpUrl;
      this.replyInfo.remindingUserName = this.userName;
      this.replyInfo.remindingUserNameList = [];

      //群发
      if (this.type === 1) {
        url = this.massMessageHttpUrl;
        this.replyInfo.remindingUserName = "";
        this.replyInfo.remindingUserNameList = this.userNameList;
      }
      let data = {
        ...this.replyInfo,
        attachment: JSON.stringify(this.newAttachment),
      };
      console.log(data, "data");
      const { data: res } = await this.$http.post(url, data);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        //清空缓存
        setTimeout(() => {
          this.storeMessage();
        }, 500);
        this.$emit("confirm");
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        });
      }
    },
    handleImgSubmit() {
      var _this = this;
      let arr = [];
      Object.keys(_this.listObj).map((v) => {
        arr.push(_this.listObj[v].url);
      });
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(
          "请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！"
        );
        return false;
      } else {
        if (arr.length > 9) {
          _this.$message.error(`最多可上传9张图片`);
          return false;
        }
        // _this.replyInfo.replyPicture = arr.toString();
        //   _this.$emit('successCBK', arr);
        _this.listObj = [];
        //   _this.imgDialogVisible = false;
      }
      if (_this.attachmentList.length > 0) {
        _this.replyInfo.attachment = JSON.stringify(this.attachmentList);
      } else {
        _this.replyInfo.attachment = "";
      }
      return true;
    },
    handleImgRemove(file, fileList) {
      Oss.imgRemove(file, this.listObj);
    },
    handleImgSuccess(response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
    },
    beforeImgUpload(file) {
      const _self = this;
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        _self.$message.error("请上传jpg,jpeg,png格式的图片！");
        return false;
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/;
      if (specialReg.test(file.name)) {
        _self.$message.error(
          "文件名中不能包含以下字符 ，；：｛｝* 请检查后修改文件名后再上传"
        );
        return false;
      }
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$set(_self, 'imgDataObj', {});
        _self.$http
          .get("aliyun/oss/policy")
          .then((response) => {
            var num = ""; //定义编号
            for (
              var i = 0;
              i < 4;
              i++ //4位随机数，用以加在时间戳后面。
            ) {
              num += Math.floor(Math.random() * 10);
            }
            num = new Date().getTime() + num; //时间戳，用来生成编号。
            _self.imgDataObj.policy = response.data.data.policy;
            _self.imgDataObj.signature = response.data.data.signature;
            _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
            _self.imgDataObj.key =
              response.data.data.dir + "/order/" + num + "${filename}";
            _self.imgDataObj.dir = response.data.data.dir + "/order";
            _self.imgDataObj.host = response.data.data.host;
            _self.imgDataObj.timeStamp = num;
            file.timeStamp = num;
            Oss.imgCompress(file, this.listObj, resolve, reject);
          })
          .catch((err) => {
            reject(true);
          });
      });
    },
    handlePreview() {
      // console.log(file);
    },
    handleRemove(file, fileList) {
      for (let i = 0; i < this.attachmentList.length; i++) {
        let attach = this.attachmentList[i];
        if (file.name == attach.name) {
          this.attachmentList.splice(i, 1);
        }
      }
    },
    beforeUploadFile(file) {
      const extension = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      // const size = file.size / 1024 / 1024
      if (
        extension !== ".xls" &&
        extension !== ".xlsx" &&
        extension !== ".pdf" &&
        extension !== ".mp4" &&
        extension !== ".ai" &&
        extension !== ".zip" &&
        extension !== ".rar"
      ) {
        this.$message.warning("只能上传excel、pdf文件、ai、zip、rar文件");
        return false;
      }
    },
    beforeRemove() {
      // return this.$confirm(`${this.$t('orderList.orderList107')} ${file.name}?`);
    },
    // 批量导入成功回调
    handleOrderInfo() {
      console.log("success");
      // console.log(data)
    },
    // 超过最大上传限度
    handleExceed(files, fileList) {
      this.$message.error(`最多可上传${this.limit}个附件`);
    },
    //图片超出最大上传限度
    handleExceedImage(files, fileList) {
      this.$message.error(`最多可上传9张图片`);
    },
    async excelUploadRequest(file) {
      let formdata = new FormData();
      formdata.append("file", file.file);
      const { data: res } = await this.$http.post(
        "cmUser/message/uploadFile",
        formdata
      );
      if (res.code === 200) {
        let { fileName, filePath } = res.data;
        this.attachmentList.push({ name: fileName, url: filePath });
      }
    },
    onClose() {
      this.$emit("update:visiable", false);
    },
    doReset() {
      return new Promise((resolve) => {
        (this.replyInfo.remindingTitle = ""),
          (this.replyInfo.remindingTitleJa = ""),
          (this.replyInfo.remindingContent = ""),
          (this.replyInfo.url = ""),
          (this.replyInfo.replyPicture = ""),
          (this.replyInfo.attachment = ""),
          (this.attachmentList = []);
        this.listObj = [];
        this.newAttachment = []
        this.replyInfo.video = ""
        resolve();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.paste-img {
  position: absolute;
  top: 0;
  left: 1px;
  width: 1px;
  height: 1px;
  z-index: 999;
}

.messageTip {}
</style>
